import styled from "styled-components";
import { useParams } from "react-router-dom";
import SideBar from "../../../../components/Sidebar";
import { useEffect } from "react";
import AccountCategories from "./AccountCategories";
import VATCodes from "./VATCodes";
import Regions from "./Regions";
import FinancialYears from "./FinancialYears";
import FieldProperties from "./FieldProperties";

const StyledGeneralTables = styled.div`
    display: flex;
`;

function GeneralTables(props) {

    let defaultPath = '/generaltables/';

    let defaultPagePath = 'accountcategories';
    let {subPagePath} = useParams();

    let items = [
        {text: 'Account categories', path: 'accountcategories'},
        {text: 'VAT codes', path: 'vatcodes'},
        {text: 'Regions', path: 'regions'},
        {text: 'Financial years', path: 'financianyears'},
        {text: 'Field properties', path: 'fieldproperties'},
    ];

    let loadedPage = false;
    useEffect(() => {
        if (!loadedPage) {
            loadedPage = true;
            props.setSmallPageTitle('');
        }
    });

    return (
        <StyledGeneralTables>
            <SideBar title={'Settings'} items={items} defaultPath={defaultPath} selectedSubPagePath={subPagePath ? subPagePath : defaultPagePath} {...props}></SideBar>
            {(!subPagePath || subPagePath === '' || subPagePath === 'accountcategories') && <AccountCategories {...props}></AccountCategories>}
            {(!subPagePath || subPagePath === '' || subPagePath === 'vatcodes') && <VATCodes {...props}></VATCodes>}
            {(!subPagePath || subPagePath === '' || subPagePath === 'regions') && <Regions {...props}></Regions>}
            {(!subPagePath || subPagePath === '' || subPagePath === 'financianyears') && <FinancialYears {...props}></FinancialYears>}
            {(!subPagePath || subPagePath === '' || subPagePath === 'fieldproperties') && <FieldProperties {...props}></FieldProperties>}
        </StyledGeneralTables>
    )
}

export default GeneralTables;